// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1tSGq","insightsList":"newBusinessInsightsMenu_insightsList__2zPDb","active":"newBusinessInsightsMenu_active__27E23"};